import Base from './Base';
import i18n from '../../internationalization/internationalization';
import React from 'react';
import Routes from './Routes';
import { BrowserBackHOC } from './BrowserBackHOC';
import { HashRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ScrollToTop } from '../../common/components';
import { StoreProvider } from '../../store/store';

export default function AppRouter(): JSX.Element {
  return (
    <StoreProvider>
      <I18nextProvider i18n={i18n}>
        <Router>
          <BrowserBackHOC>
            <Base>
              <ScrollToTop />
              <Routes />
            </Base>
          </BrowserBackHOC>
        </Router>
      </I18nextProvider>
    </StoreProvider>
  );
}
